import React from 'react';
import { Routes, Route } from 'react-router-dom'
import 'react-tiny-fab/dist/styles.css';

import './i18n/config';
import './App.css';

import Home from './pages/home/Home';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import ContactUs from './pages/contactUs/ContactUs';
import { useTranslation } from 'react-i18next';
import ToastComponent from './components/toast/Toast';
import About from './pages/about/About';
import Products from './pages/products/Products';
import ProductViewer from './pages/productViewer/ProductViewer';

function App() {
  const { t } = useTranslation();

  return (
    <div className='App'>
      <ToastComponent />
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about-us' element={<About />} />
        <Route path='/products' element={<Products />} />
        <Route path='/products/glassware' element={
          <ProductViewer
            banner={require('./category/assets/glassware/banner.webp')}
            data={[
              { image: require('./category/assets/glassware/0.webp') },
              { image: require('./category/assets/glassware/1.webp') },
              { image: require('./category/assets/glassware/2.webp') },
              { image: require('./category/assets/glassware/3.webp') },
              { image: require('./category/assets/glassware/4.webp') },
              { image: require('./category/assets/glassware/5.webp') },
            ]}
          />
        } />
        <Route path='/products/handicraft' element={
          <ProductViewer
            banner={require('./category/assets/handicrafts/banner.webp')}
            data={[
              { image: require('./category/assets/handicrafts/0.webp') },
              { image: require('./category/assets/handicrafts/1.webp') },
              { image: require('./category/assets/handicrafts/2.webp') },
              { image: require('./category/assets/handicrafts/3.webp') },
              { image: require('./category/assets/handicrafts/4.webp') },
              { image: require('./category/assets/handicrafts/5.webp') },
            ]}
          />
        } />
        <Route path='/products/homedecor' element={
          <ProductViewer
            banner={require('./category/assets/homedecor/banner.webp')}
            data={[
              { image: require('./category/assets/homedecor/0.webp') },
              { image: require('./category/assets/homedecor/1.webp') },
              { image: require('./category/assets/homedecor/2.webp') },
              { image: require('./category/assets/homedecor/3.webp') },
              { image: require('./category/assets/homedecor/4.webp') },
              { image: require('./category/assets/homedecor/5.webp') },
            ]}
          />
        } />
        <Route path='/products/home-utility' element={
          <ProductViewer
            banner={require('./category/assets/homeUtility/banner.webp')}
            data={[
              { image: require('./category/assets/homeUtility/0.webp') },
              { image: require('./category/assets/homeUtility/1.webp') },
              { image: require('./category/assets/homeUtility/2.webp') },
              { image: require('./category/assets/homeUtility/3.webp') },
              { image: require('./category/assets/homeUtility/4.webp') },
              { image: require('./category/assets/homeUtility/5.webp') },
            ]}
          />
        } />
        <Route path='/products/silverware' element={
          <ProductViewer
            banner={require('./category/assets/silverware/banner.webp')}
            data={[
              { image: require('./category/assets/silverware/0.webp') },
              { image: require('./category/assets/silverware/1.webp') },
              { image: require('./category/assets/silverware/2.webp') },
              { image: require('./category/assets/silverware/3.webp') },
              { image: require('./category/assets/silverware/4.webp') },
              { image: require('./category/assets/silverware/5.webp') },
            ]}
          />
        } />
        <Route path='/products/mmtc' element={
          <ProductViewer
            banner={require('./category/assets/mmtc/banner.webp')}
            data={[
              { image: require('./category/assets/mmtc/0.webp') },
              { image: require('./category/assets/mmtc/1.webp') },
              { image: require('./category/assets/mmtc/2.webp') },
              { image: require('./category/assets/mmtc/3.webp') },
              { image: require('./category/assets/mmtc/4.webp') },
              { image: require('./category/assets/mmtc/5.webp') },
            ]}
          />
        } />
        <Route path='/products/tableware' element={
          <ProductViewer
            banner={require('./category/assets/tableware/banner.webp')}
            data={[
              { image: require('./category/assets/tableware/0.webp') },
              { image: require('./category/assets/tableware/1.webp') },
              { image: require('./category/assets/tableware/2.webp') },
              { image: require('./category/assets/tableware/3.webp') },
              { image: require('./category/assets/tableware/4.webp') },
              { image: require('./category/assets/tableware/5.webp') },
            ]}
          />
        } />

        <Route path='/contact-us' element={<ContactUs />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
